// Copyright (c) 2017 Deere & Company

const flattenLeadAccounts = leadAccounts =>
    leadAccounts.map(account => ({
        ...account,
        leadAccount: account.leadAccount.account,
        leadAccountDisplayName: account.leadAccount.name
    }));

const flattenCities = (leadAccount, cities) =>
    cities.map(city => ({
        ...city,
        city: city.city,
        leadAccount: leadAccount.leadAccount.account,
        leadAccountDisplayName: leadAccount.leadAccount.name
    }));

const flattenAccounts = (leadAccount, city, accounts) =>
    accounts.map(account => ({
        ...account,
        account: account.subAccount.account,
        city: city.city,
        leadAccount: leadAccount.leadAccount.account,
        leadAccountDisplayName: leadAccount.leadAccount.name
    }));

const dfs = (arr, fn) => {

    let data;
    const itr = arr.entries();

    while (!data) {

        try {

            const next = itr.next().value[1];

            data = fn(next);

        } catch (e) {

            break;

        }

    }

    return data;

};

const findAccount = (accountSummary, query, leadAccount, city) => {

    const fn = account => (account.id === query) ?
        ({
            detail: {
                data: account,
                display: [leadAccount.leadAccount.name, city.city, account.subAccount.account]
            },
            rowData: flattenAccounts(leadAccount, city, [account])
        }) :
        null;

    return dfs(accountSummary, fn);

};

const findCity = (citySummary, query, leadAccount) => {

    const fn = city => (city.id === query) ?
        ({
            detail: {
                data: city,
                display: [leadAccount.leadAccount.name, city.city]
            },
            rowData: flattenAccounts(leadAccount, city, city.accountSummary)
        }) :
        findAccount(city.accountSummary, query, leadAccount, city);

    return dfs(citySummary, fn);

};

const findLeadAccount = (reimbursementSummary, query) => {

    const fn = leadAccount => (leadAccount.id === query) ?
        ({
            detail: {
                data: leadAccount,
                display: [leadAccount.leadAccount.name]
            },
            rowData: flattenCities(leadAccount, leadAccount.citySummary)
        }) :
        findCity(leadAccount.citySummary, query, leadAccount);

    return dfs(reimbursementSummary, fn);

};

export const findData = (reimbursementSummary, query) =>
    findLeadAccount(reimbursementSummary, query) || {
        detail: {
            data: {},
            display: []
        },
        rowData: flattenLeadAccounts(reimbursementSummary)
    };



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/services/find-data.js